// extracted by mini-css-extract-plugin
module.exports = {"header":"MainMenu_header__2BAIJ","link":"MainMenu_link__lk44T","activeLink":"MainMenu_activeLink__3wv5F"};